export const mockData  = {
    theme_settings:{
        theme_settings: {
            project_store_name: 'comda',
            api_beckend_url :'/'
        }
    },
    Shopify:{
        country:'USA',
        routes:{
            root:'/'
        },
        shop:"devcomda.myshopify.com",
    }

}

